module.exports = __webpack_public_path__ + "img/login_background@2x.ff1c7e0e.jpg";